<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="'50%'">
    <v-card v-if="itemDetail">
      <v-card-title>{{title}}</v-card-title>
      <v-card-text>
        <v-layout v-for="col in getDialogKeys" :key="col.value">
          <v-flex>
            <v-switch v-if="col.value === 'hidden'"
                      v-model="itemDetail[col.value]"
                      :label="col.text"
            ></v-switch>
            <v-menu v-else-if="col.value === 'startTime' || col.value === 'endTime'"
                ref="menu"
                v-model="col.menu"
                :return-value="itemDetail[col.value]"
                transition="scale-transition"
                offset-y
                min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="itemDetail[col.value]"
                    :label="col.text"
                    :color="Theme.GREEN"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="itemDetail[col.value]"
                  :header-color="Theme.GREEN"
                  :color="Theme.GREEN"
                  no-title
                  scrollable>
              </v-date-picker>
            </v-menu>
            <v-select v-else-if="col.options"
                      :color="Theme.GREEN"
                      :items="col.options"
                      :label="col.text"
                      item-text="text" item-value="key"
                      v-model="itemDetail[col.value]"/>
            <v-select v-else-if="col.value === 'productId'"
                      :color="Theme.GREEN"
                      :items="products"
                      :label="col.text"
                      item-text="productName" item-value="productId"
                      v-model="itemDetail[col.value]"/>
            <v-text-field v-else v-model="itemDetail[col.value]"
                          :label="col.text"
                          :color="Theme.GREEN"></v-text-field>
            <img style="width: 25%;" v-if="col.isImage" :src="itemDetail[col.value]" />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-text-field v-if="itemDetail.enableType === 2" v-model="itemDetail.saleURL"
                        :label="'自訂連結'"
                        :color="Theme.GREEN"></v-text-field>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/mixins/common";
import {mapActions} from 'vuex';

export default {
  name: "news_detail",
  mixins: [common],
  props: {
    title:String,
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      saveLoading: false,
      menu: false,
      products: [],
    };
  },
  created() {
    this.loadProductData();
  },
  mounted() {
  },
  computed: {
    getDialogKeys() {
      return [
        {value: 'title', text: '標題'},
        {value: 'type', text: '類型', options: this.getHomeType},
        {value: 'hidden', text: '隱藏'},
        {value: 'sort', text: '排序'},
        {value: 'pcURL', text: 'PC網址', isImage: true},
        {value: 'mobileURL', text: '手機網址', isImage: true},
        {value: 'startTime', text: '開始時間' , menu: false},
        {value: 'endTime', text: '結束時間' , menu: false},
        {value: 'productId', text: '連結商品'},
        { value:'enableType', text:'連結商品/系列/自訂', sortable: false ,options: [
            { key: 0, text: '連結商品'},
            { key: 1, text: '連結商品的系列'},
            { key: 2, text: '自訂連結'},
          ]},
      ];
    },
  },
  methods: {
    ...mapActions(['saveHomeInfo','getAllProductList']),
    async loadProductData(){
      const res = await this.getAllProductList({});
      const result = res.data;
      console.log(`getAllProductList ${JSON.stringify(result)}`);
      this.products = result.body.list;
      this.$forceUpdate();
    },
    cancelEvent() {
      this.$emit('cancelEvent');
    },
    async confirmEvent() {
      this.saveLoading = true;

      if (this.itemDetail.startTime &&  this.itemDetail.startTime !=='' && this.itemDetail.startTime.indexOf(':') === -1){
        this.itemDetail.startTime = `${this.itemDetail.startTime} 00:00:00`;
      }

      if (this.itemDetail.endTime &&  this.itemDetail.endTime !=='' && this.itemDetail.endTime.indexOf(':') === -1){
        this.itemDetail.endTime = `${this.itemDetail.endTime} 23:59:59`;
      }

      if (this.itemDetail.enableType === 1){
        const find = this.products.find(p=>p.productId === this.itemDetail.productId);
        if (find){
          this.itemDetail.productGroup = find.productGroup;
        }
      }

      console.log(`save ${JSON.stringify(this.itemDetail)}`);
      const res = await this.saveHomeInfo({token: '', info: this.itemDetail});
      const result = res.data;
      if (result.code === 0) {
        this.$emit('confirmEvent', this.itemDetail);
      } else {
        this.showMessageDialog('錯誤', result.message ? result.message : '儲存失敗');
      }
      this.saveLoading = false;

    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
  }
}
</script>

<style scoped>

</style>
